import * as React from 'react'
import { SVGProps } from 'react'
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m21.026 10.58.738-2.46c.42-1.397.628-2.095.477-2.648a2 2 0 0 0-.869-1.168C20.886 4 20.157 4 18.7 4H4.692l1.45 6.28c.306 1.328.46 1.992.82 2.487a3 3 0 0 0 1.248.992C8.773 14 9.455 14 10.818 14h5.61c1.282 0 1.923 0 2.463-.218a3 3 0 0 0 1.219-.907c.364-.455.548-1.068.916-2.296Z"
      opacity={0.12}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.33}
      d="M1 1h.5v0c.108 0 .161 0 .21.002a3 3 0 0 1 2.804 2.23l.048.204.13.564m0 0 1.45 6.28c.306 1.328.46 1.992.82 2.488a3 3 0 0 0 1.247.991C8.773 14 9.455 14 10.82 14h5.61c1.281 0 1.922 0 2.462-.218a3 3 0 0 0 1.219-.907c.364-.455.548-1.068.916-2.296l.738-2.46c.419-1.396.628-2.094.477-2.647a2 2 0 0 0-.869-1.168C20.886 4 20.157 4 18.7 4H4.692ZM14 14H6a2 2 0 0 0-2 2v0a2 2 0 0 0 2 2h15m-10 2a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm8 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
    />
  </svg>
)
export default SvgComponent
